import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessagingConstants } from '../utils/messaging-constants';

@Component({
    selector: 'pershing-message-dialog',
    templateUrl: 'pershing-message-dialog.html'
 })
  export class PershingMessageDialog {
    messageText: string;
    messageType: string;
    buttonLabel: string;
    // acceptButton: string;
    // cancelButton: string;
    styleClasses: string[];
    positiveActionConfig: any;
    negativeActionConfig: any;
    constructor(@Inject(MAT_DIALOG_DATA) public messageDetails: any) {
            console.log('Message Dlg Comp');
            console.log(this.messageType);
            this.messageText = messageDetails.messageContent;
            this.messageType = messageDetails.messageType;
            // this.acceptButton = messageDetails.acceptButton;
            // this.cancelButton = messageDetails.cancelButton;
            this.positiveActionConfig = messageDetails.positiveActionConfig;
            this.negativeActionConfig = messageDetails.negativeActionConfig;
            this.buttonLabel = messageDetails.buttonLabel;
            let messageColor: string = MessagingConstants.MESSAGE_COLOR_CONFIRM;
            let messageIcon: string = MessagingConstants.CONFIRM_MESSAGE_ICON;
            if (this.messageType === MessagingConstants.MESSAGETYPE_ERROR) {
                messageColor = MessagingConstants.MESSAGE_COLOR_ERROR;
                messageIcon = MessagingConstants.ERROR_MESSAGE_ICON;
            } else if (this.messageType === MessagingConstants.MESSAGETYPE_WARN) {
                messageColor = MessagingConstants.MESSAGE_COLOR_WARNING;
                messageIcon = MessagingConstants.WARNING_MESSAGE_ICON;
            } else if (this.messageType === MessagingConstants.MESSAGETYPE_CONFIRM) {
                messageColor = MessagingConstants.MESSAGE_COLOR_CONFIRM;
                messageIcon = MessagingConstants.CONFIRM_MESSAGE_ICON;
            } else if (this.messageType === MessagingConstants.MESSAGETYPE_INFO) {
                messageColor = MessagingConstants.MESSAGE_COLOR_INFO;
                messageIcon = MessagingConstants.INFO_MESSAGE_ICON;
            } else if (this.messageType === MessagingConstants.MESSAGETYPE_TIP) {
                messageColor = MessagingConstants.MESSAGETYPE_COLOR_TIP;
                messageIcon = MessagingConstants.TIP_MESSAGE_ICON;
            }
            this.styleClasses = [messageColor, messageIcon];
      }

}
